import type { V2GetProjectByIdApiArg } from "@generated";

/*
 * The one project query the project chrome makes. ProjectNavigationProvider
 * and SowHeader both call useV2GetProjectByIdQuery with these args, so under
 * react-nav they share a single cache entry; diverging args split it into
 * two fetches.
 *
 * V2::ProjectResource only emits relationship linkage for included
 * relationships, so each include here is something a reader needs the id of:
 * - psa-project: PSA nav item and SowHeader's Push To PSA new/edit choice
 * - document-template: GenerateDocument's preselected template
 */
export const projectChromeQueryArgs = (id: string): V2GetProjectByIdApiArg => ({
  id,
  include: ["psa-project", "document-template"],
});
